<template src="@/templates/file/dateRange.html"></template>

<script>
import { downloadFileMixin } from "@/mixins/functions/downloadFileMixin";
import WorkingWithChildrenModel from "@/models/workingWithChildrenModel";
import PoliceCheckModel from "@/models/policeCheckModel";
import ClearanceCheckModel from "@/models/clearanceCheckModel";
import datePickerSingle from "@/components/datePicker/Single";
import moment from "moment";

export default {
  name: "dateRange",
  props: ["fileList", "currentModel", "checkType", "noEndDate"],
  mixins: [downloadFileMixin],
  components: {
    datePickerSingle,
  },
  data() {
    return {
      dateRangePopUp: true,
      dataValidation: false,
      workingWithChildrenModel: new WorkingWithChildrenModel(),
      policeCheckModel: new PoliceCheckModel(),
      clearanceCheckModel: new ClearanceCheckModel(),
      pushTo: "dateRange",
      uploaded_file: {},
      fileExtension: "",
      mime_type: "",
      fromDatePicker: "fromDatePicker",
      toDatePicker: "toDatePicker",
      previewImage: "",
      finished_uploading: 0,
      uploading_file_started: 0,
      size_of_chunked_file: 0,
      uploaded_file_name: "",
      referenceText: "",
      infoAboutDocuments: "",
      isNoEndDate: 0,
    };
  },
  created() {
    this.uploaded_file = this.fileList.dataUrl;
    console.log(this.uploaded_file);
    this.checkIfChunkRequired;
    this.initialParams();
  },
  watch: {
    fromDatePicker: {
      handler: function () {
        if (this.toDatePicker !== "Invalid date") {
          this.validator(this.fromDatePicker);
        }
      },
      deep: true,
    },
    toDatePicker: {
      handler: function () {
        if (this.fromDatePicker !== "Invalid date") {
          this.validator(this.toDatePicker);
        }
      },
      deep: true,
    },
  },
  methods: {
    initialParams() {
      this.isNoEndDate = this.noEndDate;
      switch (this.checkType) {
        case "WorkingWithChildrenCheck": {
          this.infoAboutDocuments =
            "All Graduates accepts WWCC as valid until the issued expiry date. Where not stated, WWCC are accepted as valid for 3 years from Date of Issue. Please check your documentation carefully.";
          break;
        }
        case "PoliceCheck": {
          this.infoAboutDocuments =
            "All Graduates accepts Police checks as valid for 3 years from the Date of Issue. Please check your documentation carefully.";
          break;
        }
      }
    },
    closeDateRange() {
      this.reset();
      Event.$emit("hideDateRangeComp");
    },
    reset() {
      this.chunkFiles[this.pushTo] = [];
      this.finished_uploading = 0;
      this.uploading_file_started = 0;
      this.uploaded_file = {};
      this.current_file_name = "";
      this.uploaded_file_name = "";
      this.fileExtension = "";
      this.mime_type = "";
      this.isFileUploaded = false;
      this.loadingTheFile = true;
    },
    updateDatePickedSingle(value, identifier) {
      this[identifier] = moment(String(value)).format("ddd DD MMM YYYY");
    },
    validator(datePickerType) {
      if (datePickerType !== "Invalid date") {
        this.dataValidation = true;
      } else {
        this.dataValidation = false;
      }

      if (datePickerType !== "Invalid date" && this.isNoEndDate > 0) {
        let currentDate = moment(new Date(), "ddd DD MMM YYYY").unix();
        let validFrom = moment(this.fromDatePicker, "ddd DD MMM YYYY").unix();

        console.log(currentDate);
        console.log(validFrom);

        if (validFrom > currentDate) {
          this.dataValidation = false;
          let error = "Completion Date must be less than or equal to Today.";
          this.validationError(error);
        } else {
          this.dataValidation = true;
        }
      }
    },
    uploadFile() {
      this.size_of_chunked_file = this.chunkFiles[this.pushTo].length;
      if (this.size_of_chunked_file === 1) {
        this.finished_uploading = 1;
      }

      this[this.currentModel].data = {
        validFrom: this.fromDatePicker,
        validTo: this.noEndDate == 0 ? this.toDatePicker : "",
        noEndDate: this.noEndDate,
        base64: this.chunkFiles[this.pushTo][this.uploading_file_started],
        finished_uploading: this.finished_uploading,
        file_name: this.uploaded_file_name,
        type: this.mime_type,
        ext: this.fileExtension,
        reference: this.referenceText,
      };

      if (parseInt(this[this.currentModel].data.noEndDate) == 0) {
        this[this.currentModel].data.validTo = this.toDatePicker;
        if (
          this[this.currentModel].data.validFrom ===
            ("" || "Invalid date" || null) ||
          this[this.currentModel].data.validTo ===
            ("" || "Invalid date" || null)
        ) {
          this.dataValidation = false;
          let error = "Invalid Date. Please Input Both Valid From & To Date.";
          this.validationError(error);
          return;
        }
      } else {
        if (
          this[this.currentModel].data.validFrom ===
          ("" || "Invalid date" || null)
        ) {
          this.dataValidation = false;
          let error = "Invalid Date. Please Input Valid Completion Date.";
          this.validationError(error);
          return;
        }
      }

      if (this[this.currentModel].data.base64 === "") {
        let error = "Error with uploaded file. Try again";
        this.validationError(error);
        return;
      }

      this[this.currentModel]
        .saveFile(this.checkType)
        .then((modelRes) => {
          let response = modelRes.response.data;

          if (response.error === false) {
            if (
              this.size_of_chunked_file == 1 ||
              this.finished_uploading == 1
            ) {
              // console.log('Just 1 chunked items of file or finished uploading');
              // console.log('Upload Done successfully');
              this.successMessage();
              this.reset();
              Event.$emit("hideDateRangeComp");
              Event.$emit("refreshCheck");
            } else {
              this.update_the_states();
            }
          } else {
            let errorMessage = "Upload error. " + response.error;
            this.saveError(errorMessage);
          }
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.saveError(errorMessage);
          console.error(PCError);
        });
    },
    update_the_states() {
      if (this.finished_uploading == 0) {
        this.uploading_file_started++;

        if (this.uploading_file_started == this.size_of_chunked_file - 1) {
          console.log("Finished the recursive call");
          this.finished_uploading = 1;
        } else {
          console.log("Recurrsive call of function");
        }
      }

      this.uploadFile();
    },
    successMessage() {
      this.$vs.notify({
        title: "Upload Success",
        text: "Successfully Saved",
        time: 4000,
        color: "success",
        position: "top-center",
      });
    },
    saveError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 5000,
        color: "danger",
        position: "top-center",
      });
    },
    validationError(errorMessage) {
      this.$vs.notify({
        title: "Validation Error",
        text: errorMessage,
        time: 8000,
        color: "danger",
        position: "top-center",
      });
    },
  },
};
</script>
